import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_progress_circular = _resolveComponent("v-progress-circular");
    const _component_v_overlay = _resolveComponent("v-overlay");
    return (_openBlock(), _createBlock(_component_v_overlay, {
        value: _ctx.isFetching,
        opacity: _ctx.opacity,
        absolute: ""
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: _ctx.color,
                size: _ctx.size
            }, null, 8 /* PROPS */, ["color", "size"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["value", "opacity"]));
}
